import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { UtilsService } from 'src/app/services/utils.service';
import { AppSettings } from 'src/app/app.settings';
import { GolfService } from 'src/app/services/golf.service';
import { crossMsg, CrossService, drContact, drRepository, Filter, FilterList, Filters, GetFieldValuesReq, SetContactReq, SetGeoLocationReq } from '@robisoft/cross-library';
import { GalleryHotelComponent } from 'src/app/dialogs/gallery-hotel/gallery-hotel.component';
import { CrossContactsService } from 'src/app/cross-utils/services/cross-contacts.service';
import { GetContactsReq } from 'src/app/models/Contact';
import { GetHotelInfoResp } from 'src/app/models/Pacchetti';
import { PrivacyComponent } from 'src/app/cross-utils/privacy/privacy.component';
import { Subscription } from 'rxjs';
import { BiglietteriaComponent } from 'src/app/dialogs/biglietteria/biglietteria.component';

declare var google: any;

@Component({
  selector: 'app-ricerca-golfclub',
  templateUrl: './ricerca-golfclub.component.html',
  styleUrls: ['./ricerca-golfclub.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})

export class RicercaGolfclubComponent implements OnInit, OnDestroy, AfterViewInit {

  searchText: string;
  golfclubs: drContact[];

  regioni: string[];
  province: string[];
  currReg: string;
  currProv: string;

  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;
  geocoder: google.maps.Geocoder | null;
  bounds: google.maps.LatLngBounds;
  zoom: number;
  center: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    mapTypeId: 'hybrid',
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    maxZoom: 15,
    minZoom: 8,
  };
  display: any;
  marker: google.maps.Marker;
  infoWindow: google.maps.InfoWindow;
  markers: google.maps.Marker[];

  public partner: string;
  sub: Subscription;
  firstRun: boolean;

  constructor(private router: Router,
    private golfService: GolfService,
    public sanitizer: DomSanitizer,
    private crossService: CrossService,
    private dialog: MatDialog,
    private contactsService: CrossContactsService,
    public app: AppComponent,
    public utils: UtilsService) {
    this.golfclubs = [];
    this.regioni = [];
    this.province = [];
    this.currReg = '';
    this.currProv = '';
    this.searchText = '';
    this.center = {
      lat: 45.4351326,
      lng: 11.6746138
    };
    this.zoom = 8;
    this.geocoder = null;
    this.markers = [];
    this.infoWindow = new google.maps.InfoWindow({
      content: 'loading'
    });
    this.sub = new Subscription();
    this.firstRun = false;
  }

  async ngOnInit() {
    await this.getRegions();
  }

  ngOnDestroy() {
  }

  async getRegions() {
    let req = new GetFieldValuesReq();
    req.store = this.app.store;
    req.fieldName = 'AddressRegion';
    let resp = await this.contactsService.getFieldValues(AppSettings.API_ENDPOINT, req);
    if (!resp.error) {
      this.regioni = resp.values;
    }
  }

  async getProvinces(region: string) {
    this.currProv = '';
    if (region) {
      let req = new GetFieldValuesReq();
      req.store = this.app.store;
      req.fieldName = 'AddressProvince';
      req.filters = new Filters();
      let list = new FilterList();
      list.filters.push(new Filter('AddressRegion', '=', region));
      req.filters.and_or = 'and';
      req.filters.filterLists.push(list);
      let resp = await this.contactsService.getFieldValues(AppSettings.API_ENDPOINT, req);
      if (!resp.error) {
        this.province = resp.values;
      }
      this.refreshGolfclubs();
    }
  }

  async ngAfterViewInit() {

    this.sub = this.app.initialized.subscribe(async (init) => {
      if (init && !this.firstRun) {
        //await this.refreshGolfclubs();
      }
    });
  }

  async filterGolfClub(): Promise<void> {

  }

  buildMap() {
    let mapOptions = {
      center: this.center,
      zoom: this.zoom,
      // mapTypeId: google.maps.MapTypeId.TERRAIN,
      mapTypeControlOptions: {
        mapTypeIds: [
          google.maps.MapTypeId.ROADMAP
        ]
      },
      draggableCursor: 'default',  //simple arrow style
      // styles: this.mapService.mapStyle,
      streetViewControl: false,
      fullscreenControl: false,
    };
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapOptions);
    this.geocoder = new google.maps.Geocoder();
    this.bounds = new google.maps.LatLngBounds();
    /*if (this.currUser.ContactID > 0) {
      if (this.currUser.Latitude && this.currUser.Longitude) {
        let location = new google.maps.LatLng({
          lat: this.currUser.Latitude,
          lng: this.currUser.Longitude
        });
        this.map.panTo(location);  //center the map on the clicked position
        this.map.setZoom(18);
        this.currMarker = new google.maps.Marker(
          {
            position: new google.maps.LatLng(this.currUser.Latitude, this.currUser.Longitude),
            map: this.map,
            //icon: 
          });
      }
      else
        await this.getPositionFromAddress();
    }*/
  }

  async refreshGolfclubs(): Promise<void> {

    if (AppSettings.GoogleAPIKey) {
      this.buildMap();
    }

    if (!this.app.store)
      return;
    this.firstRun = true;

    let req = new GetContactsReq();
    req.store = this.app.store;
    req.pageNum = 1;
    req.pageSize = 999;
    req.region = this.currReg;
    req.province = this.currProv;

    if (this.currReg || this.currProv) {

      // In teoria risolto, ricostruendo la mappa
      /* if (this.markers)
        this.markers.forEach(mark => {
          mark.setMap(null);
        }); */

      this.golfclubs = [];
      this.markers = [];
      //this.bounds = new google.maps.LatLngBounds();

      const resp = await this.golfService.GetGolfclubs(req);
      if (resp && resp.contacts && resp.contacts.length > 0) {
        this.golfclubs = resp.contacts;

        let index = 0;
        const top = this;

        for (const club of this.golfclubs) {
          /*
          club.D.forEach((d, i) => {
            if (club.D[i])
              club.D[i] = DateTime.fromISO(club.D[i]);
          });
          */

          let error = '';
          if (!club.Latitude || !club.Longitude)
            error = await this.getPositionFromAddress(club);

          /*this.marker = new google.maps.Marker({
            position: new google.maps.LatLng(club.Latitude, club.Longitude),
            map: this.map,
            icon: '/assets/img/pin-golfclub.png'
          });*/

          if (error) {
            console.log('error', error);
          } else {
            let address = '';
            address += club.AddressStreet;
            if (club.AddressCity)
              address += ' - ' + club.AddressCity;
            if (club.AddressProvince)
              address += ' (' + club.AddressProvince + ')';
            if (club.AddressPostalCode)
              address += ' - ' + club.AddressPostalCode;

            let fumetto = "<div><strong>" + club.Company + "</strong><br />" + address;
            if (club.Phone)
              fumetto += "<br />" + club.Phone;

            this.markers.push(
              new google.maps.Marker({
                position: new google.maps.LatLng(club.Latitude, club.Longitude),
                map: this.map,
                icon: '/assets/img/pin-golfclub.png',
                zIndex: index,
                title: club.Company,
                // animation: google.maps.Animation.BOUNCE
              })
            );

            let ltln = null;
            if (this.markers && this.markers[index])
              ltln = this.markers[index].getPosition();
            if (ltln)
              this.bounds.extend(ltln);

            /* let infoWindow = new google.maps.InfoWindow({
              content: 'loading'
            }); */

            // google.maps.event.addListener(this.markers[index], 'click', function() {
            this.markers[index].addListener('click', function (top: any) {
              // () => {
              if (top.infoWindow) {
                top.infoWindow.close();
              } else {
                top.infoWindow = new google.maps.InfoWindow({
                  content: 'loading'
                });
              }
              top.infoWindow.setContent('<b>' + club.Company + '</b><br />' + address);
              top.infoWindow.open(top.map, this);
              // }

            });

            index += 1;

          }

        } //);

      }

      let ltln = null;
      if (this.markers && this.markers.length > 0)
        ltln = this.markers[this.markers.length - 1].getPosition();
      if (ltln) {
        this.map.panTo(ltln);  //center the map on the clicked position
        if (this.markers.length > 1) {
          this.map.setZoom(18);
          this.map.fitBounds(this.bounds);
        }
        else {
          this.map.setZoom(11);
          //this.map.fitBounds(this.bounds);
        }
      }

    }

  }

  async testWait() {
    alert('going to wait for 5 second');
    await this.wait(5000);
    alert('finally wait is over');
  }

  wait(time) {
    return new Promise(resolve => {
      setTimeout(resolve, time);
    });
  }

  async getPositionFromAddress(club: drContact): Promise<string> {  // map: google.maps.Map
    let error = '';
    var geocoderRequest: google.maps.GeocoderRequest;
    //geocoderRequest = { 'location': this.latLng };
    let address = club.AddressStreet;
    address += club.AddressCity ? ', ' + club.AddressCity : '';
    address += club.AddressPostalCode ? ' - ' + club.AddressPostalCode : '';
    geocoderRequest = { 'address': address };

    if (address) {
      await this.wait(500);
      const resp = await this.geocoder?.geocode(geocoderRequest, async (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          club.Latitude = results[0].geometry.location.lat();
          club.Longitude = results[0].geometry.location.lng();
          let req2 = new SetGeoLocationReq();
          req2.contactGUID = club.ContactGUID;
          req2.store = this.app.store;
          req2.latitude = club.Latitude;
          req2.longitude = club.Longitude;
          let resp2 = await this.contactsService.setGeoLocation(AppSettings.API_ENDPOINT, req2); //.saveContact(req2);

          //alert(JSON.stringify(results[0].geometry.location));
        } else {
          //console.log(JSON.stringify(status));
          console.error('ERRORE');
          error = 'Non riesco a trovare l\'indirizzo su google maps';
        }
      }); //, (results, status) => {
      //  if (status === google.maps.GeocoderStatus.OK) {

    }

    if (error)
      console.log('error', error);

    /*  if (found && resp && resp.results && resp.results.length > 0 && resp.results[0]) {
       club.Latitude = resp.results[0].geometry.location.lat();
       club.Longitude = resp.results[0].geometry.location.lng();
       let req2 = new SetContactReq();
       req2.contact = club;
       req2.myToken = this.app.mytoken;
       req2.gridConfig = 'my-account';
       let resp2 = await this.contactsService.setContact(AppSettings.API_ENDPOINT, req2); //.saveContact(req2);
       if (!resp2.error) {
 
       }
     } else {
       error = 'Non riesco a trovare l\'indirizzo su google maps';
     } */
    //  }
    // });

    return error;
  }

  getThumb(thumb: string, i: number): string {
    if (thumb)
      return AppSettings.URL + '/' + thumb;
    else
      return AppSettings.URL + '/public/progetti/project-' + (i % 9) + '.jpg';
  }

  public sanitizeImage(image: string) {
    const url = AppSettings.URL;
    if (image.startsWith('img/'))
      return this.sanitizer.bypassSecurityTrustStyle(`url('${url}/${image}')`);
    else
      return this.sanitizer.bypassSecurityTrustStyle(`url('${url}/img/${this.app.store}/${image}')`);
  }

  getAddress(club: drContact) {
    let address = '';
    /* address += club.AddressStreet; */
    if (club.AddressCity)
      address += club.AddressCity;// address += ' - ' + club.AddressCity;
    if (club.AddressProvince)
      address += ' (' + club.AddressProvince + ')';
    /* if (club.AddressPostalCode)
      address += ' - ' + club.AddressPostalCode; */
    return address;
  }

  getWebSite(webSite: string) {
    if (webSite.indexOf('http') < 0)
      webSite = 'https://' + webSite;
    return webSite;
  }

  public titolo(pacchetto: drRepository): string {
    return this.crossService.getLangString(pacchetto.Title, this.app.currlang.toLowerCase());
  }

  public descrizione(pacchetto: drRepository): string {
    return this.crossService.getLangString(pacchetto.Description, this.app.currlang.toLowerCase());
  }

  public sanitizeUrl(image: string) {
    if (image.startsWith('img/'))
      return this.sanitizer.bypassSecurityTrustUrl(AppSettings.URL + '/' + image);
    else
      return this.sanitizer.bypassSecurityTrustUrl(AppSettings.URL + '/img/' + this.app.store + '/' + image);
  }

  getClass(index: number) {
    return 'element' + index;
  }

  formatCurrency(price: number): string {
    let ret = price.toFixed(2);
    if (this.app.currlang === 'IT' || this.app.currlang === 'DE') {
      ret = ret.replace(',', '#').replace('.', ',').replace('#', '.');
    }
    return ret;
  }

  async openGalleryDialog(hotelGallery: GetHotelInfoResp) {
    const dialogRef = this.dialog.open(GalleryHotelComponent, {
      data: hotelGallery,   /* ticket.ShopQta */
      width: '95%',
      height: '98vh'
    });
    dialogRef.afterClosed().subscribe((goto) => {
      if (goto) {
        this.router.navigate(['/carrello'], { queryParams: { store: this.app.store } });
      }
    });
  }

  async prenota(username: string) {
    let url = 'https://opengolf.it/v2/biglietti?store=' + username + '&lang=IT';
    const dialogRef = this.dialog.open(BiglietteriaComponent, {
      data: url,   /* ticket.ShopQta */
      width: '100%',
      height: '100vh',
      panelClass: 'biglietteriaDialog'
    });
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  openUrl(url: string) {
    let link = '';
    if (!url) {
      url = 'https://opengolf.it/it/privacy-policy?header=no';
    }
    if (url.startsWith('http'))
      link = url;
    else
      link = AppSettings.URL + '/img/' + this.app.store + '/' + url;

    const dialogRef = this.dialog.open(PrivacyComponent, {
      data: {
        privacyUrl: link
      },
      panelClass: 'full-screen'
    });
  }

}
